export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/noop.js
// module id = 1083
// module chunks = 0